// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BenchmarksRouteRouteImport } from './routes/_benchmarks/route'
import { Route as BlogRouteRouteImport } from './routes/blog/route'
import { Route as JsonSchemaRouteRouteImport } from './routes/json-schema/route'
import { Route as LibrariesRouteRouteImport } from './routes/libraries/route'
import { Route as BenchmarksRuntimeRouteRouteImport } from './routes/_benchmarks/_runtime/route'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ContributingIndexRouteImport } from './routes/contributing/index'
import { Route as JsonSchemaIndexRouteImport } from './routes/json-schema/index'
import { Route as LibrariesIndexRouteImport } from './routes/libraries/index'
import { Route as BenchmarksDownloadIndexRouteImport } from './routes/_benchmarks/download/index'
import { Route as BenchmarksStackIndexRouteImport } from './routes/_benchmarks/stack/index'
import { Route as ApiTweetIdRouteImport } from './routes/api/tweet.$id'
import { Route as JsonSchemaComplianceIndexRouteImport } from './routes/json-schema/compliance/index'
import { Route as JsonSchemaComplianceTabRouteImport } from './routes/json-schema/compliance/$tab'
import { Route as RepoRawSplatRouteImport } from './routes/repo/raw.$'
import { Route as BenchmarksRuntimeCodecIndexRouteImport } from './routes/_benchmarks/_runtime/codec/index'
import { Route as BenchmarksRuntimeInitializationIndexRouteImport } from './routes/_benchmarks/_runtime/initialization/index'
import { Route as BenchmarksRuntimeParsingIndexRouteImport } from './routes/_benchmarks/_runtime/parsing/index'
import { Route as BenchmarksRuntimeStandardIndexRouteImport } from './routes/_benchmarks/_runtime/standard/index'
import { Route as BenchmarksRuntimeStringIndexRouteImport } from './routes/_benchmarks/_runtime/string/index'
import { Route as BenchmarksRuntimeValidationIndexRouteImport } from './routes/_benchmarks/_runtime/validation/index'
import { Route as JsonSchemaConversionFromJsonIndexRouteImport } from './routes/json-schema/_conversion/from-json/index'
import { Route as JsonSchemaConversionToJsonIndexRouteImport } from './routes/json-schema/_conversion/to-json/index'
import { Route as JsonSchemaConversionToJsonTabRouteImport } from './routes/json-schema/_conversion/to-json/$tab'

const BenchmarksRouteRoute = BenchmarksRouteRouteImport.update({
            id: '/_benchmarks',getParentRoute: () => rootRouteImport
          })
const BlogRouteRoute = BlogRouteRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const JsonSchemaRouteRoute = JsonSchemaRouteRouteImport.update({
            id: '/json-schema',path: '/json-schema',getParentRoute: () => rootRouteImport
          })
const LibrariesRouteRoute = LibrariesRouteRouteImport.update({
            id: '/libraries',path: '/libraries',getParentRoute: () => rootRouteImport
          })
const BenchmarksRuntimeRouteRoute = BenchmarksRuntimeRouteRouteImport.update({
            id: '/_runtime',getParentRoute: () => BenchmarksRouteRoute
          })
const HomeIndexRoute = HomeIndexRouteImport.update({
            id: '/_home/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRouteRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRouteRoute
          })
const ContributingIndexRoute = ContributingIndexRouteImport.update({
            id: '/contributing/',path: '/contributing/',getParentRoute: () => rootRouteImport
          })
const JsonSchemaIndexRoute = JsonSchemaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => JsonSchemaRouteRoute
          })
const LibrariesIndexRoute = LibrariesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LibrariesRouteRoute
          })
const BenchmarksDownloadIndexRoute = BenchmarksDownloadIndexRouteImport.update({
            id: '/download/',path: '/download/',getParentRoute: () => BenchmarksRouteRoute
          })
const BenchmarksStackIndexRoute = BenchmarksStackIndexRouteImport.update({
            id: '/stack/',path: '/stack/',getParentRoute: () => BenchmarksRouteRoute
          })
const ApiTweetIdRoute = ApiTweetIdRouteImport.update({
            id: '/api/tweet/$id',path: '/api/tweet/$id',getParentRoute: () => rootRouteImport
          })
const JsonSchemaComplianceIndexRoute = JsonSchemaComplianceIndexRouteImport.update({
            id: '/compliance/',path: '/compliance/',getParentRoute: () => JsonSchemaRouteRoute
          })
const JsonSchemaComplianceTabRoute = JsonSchemaComplianceTabRouteImport.update({
            id: '/compliance/$tab',path: '/compliance/$tab',getParentRoute: () => JsonSchemaRouteRoute
          })
const RepoRawSplatRoute = RepoRawSplatRouteImport.update({
            id: '/repo/raw/$',path: '/repo/raw/$',getParentRoute: () => rootRouteImport
          })
const BenchmarksRuntimeCodecIndexRoute = BenchmarksRuntimeCodecIndexRouteImport.update({
            id: '/codec/',path: '/codec/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeInitializationIndexRoute = BenchmarksRuntimeInitializationIndexRouteImport.update({
            id: '/initialization/',path: '/initialization/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeParsingIndexRoute = BenchmarksRuntimeParsingIndexRouteImport.update({
            id: '/parsing/',path: '/parsing/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeStandardIndexRoute = BenchmarksRuntimeStandardIndexRouteImport.update({
            id: '/standard/',path: '/standard/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeStringIndexRoute = BenchmarksRuntimeStringIndexRouteImport.update({
            id: '/string/',path: '/string/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const BenchmarksRuntimeValidationIndexRoute = BenchmarksRuntimeValidationIndexRouteImport.update({
            id: '/validation/',path: '/validation/',getParentRoute: () => BenchmarksRuntimeRouteRoute
          })
const JsonSchemaConversionFromJsonIndexRoute = JsonSchemaConversionFromJsonIndexRouteImport.update({
            id: '/_conversion/from-json/',path: '/from-json/',getParentRoute: () => JsonSchemaRouteRoute
          })
const JsonSchemaConversionToJsonIndexRoute = JsonSchemaConversionToJsonIndexRouteImport.update({
            id: '/_conversion/to-json/',path: '/to-json/',getParentRoute: () => JsonSchemaRouteRoute
          })
const JsonSchemaConversionToJsonTabRoute = JsonSchemaConversionToJsonTabRouteImport.update({
            id: '/_conversion/to-json/$tab',path: '/to-json/$tab',getParentRoute: () => JsonSchemaRouteRoute
          })





const BenchmarksRuntimeRouteRouteChildren = {
  BenchmarksRuntimeCodecIndexRoute: BenchmarksRuntimeCodecIndexRoute,BenchmarksRuntimeInitializationIndexRoute: BenchmarksRuntimeInitializationIndexRoute,BenchmarksRuntimeParsingIndexRoute: BenchmarksRuntimeParsingIndexRoute,BenchmarksRuntimeStandardIndexRoute: BenchmarksRuntimeStandardIndexRoute,BenchmarksRuntimeStringIndexRoute: BenchmarksRuntimeStringIndexRoute,BenchmarksRuntimeValidationIndexRoute: BenchmarksRuntimeValidationIndexRoute
}

const BenchmarksRuntimeRouteRouteWithChildren = BenchmarksRuntimeRouteRoute._addFileChildren(BenchmarksRuntimeRouteRouteChildren)



const BenchmarksRouteRouteChildren = {
  BenchmarksRuntimeRouteRoute: BenchmarksRuntimeRouteRouteWithChildren,BenchmarksDownloadIndexRoute: BenchmarksDownloadIndexRoute,BenchmarksStackIndexRoute: BenchmarksStackIndexRoute
}

const BenchmarksRouteRouteWithChildren = BenchmarksRouteRoute._addFileChildren(BenchmarksRouteRouteChildren)




const BlogRouteRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteRouteWithChildren = BlogRouteRoute._addFileChildren(BlogRouteRouteChildren)




const JsonSchemaRouteRouteChildren = {
  JsonSchemaIndexRoute: JsonSchemaIndexRoute,JsonSchemaComplianceTabRoute: JsonSchemaComplianceTabRoute,JsonSchemaComplianceIndexRoute: JsonSchemaComplianceIndexRoute,JsonSchemaConversionToJsonTabRoute: JsonSchemaConversionToJsonTabRoute,JsonSchemaConversionFromJsonIndexRoute: JsonSchemaConversionFromJsonIndexRoute,JsonSchemaConversionToJsonIndexRoute: JsonSchemaConversionToJsonIndexRoute
}

const JsonSchemaRouteRouteWithChildren = JsonSchemaRouteRoute._addFileChildren(JsonSchemaRouteRouteChildren)




const LibrariesRouteRouteChildren = {
  LibrariesIndexRoute: LibrariesIndexRoute
}

const LibrariesRouteRouteWithChildren = LibrariesRouteRoute._addFileChildren(LibrariesRouteRouteChildren)

const rootRouteChildren = {
  BenchmarksRouteRoute: BenchmarksRouteRouteWithChildren,BlogRouteRoute: BlogRouteRouteWithChildren,JsonSchemaRouteRoute: JsonSchemaRouteRouteWithChildren,LibrariesRouteRoute: LibrariesRouteRouteWithChildren,HomeIndexRoute: HomeIndexRoute,ContributingIndexRoute: ContributingIndexRoute,ApiTweetIdRoute: ApiTweetIdRoute,RepoRawSplatRoute: RepoRawSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)